export default function getCurrencyAriaLabel(input) {
  if (input === null || input === undefined) return 'amount not available';

  const cleaned = typeof input === 'string' ? input.replace(/[£,\s]/g, '') : input.toString();

  const asNumber = Number(cleaned);
  if (!Number.isFinite(asNumber)) return 'amount not available';

  // Convert to pence (avoid float errors), round to nearest pence
  const totalPence = Math.round(asNumber * 100);

  const sign = totalPence < 0 ? 'minus ' : '';
  const absPence = Math.abs(totalPence);

  const pounds = Math.floor(absPence / 100);
  const pence = absPence % 100;

  const poundWord = pounds === 1 ? 'pound' : 'pounds';
  const penceWord = pence === 1 ? 'penny' : 'pence';

  if (pounds === 0 && pence === 0) return 'zero pounds';
  if (pounds === 0) return `${sign}${pence} ${penceWord}`;
  if (pence === 0) return `${sign}${pounds} ${poundWord}`;
  return `${sign}${pounds} ${poundWord} and ${pence} ${penceWord}`;
}
